const debugLog = v => window.woorankAssistantOptions.debug && console.log(v);
export default debugLog;
